export default __webpack_public_path__ + "static/media/wizard.2b90eb2c.png";